<template>
  <div class="repurchase_pge">
    <h1>用户复购报表</h1>
    <div class="user-options clearfix">
      <el-select
        style="width: 160px"
        v-model="curChannel.selectValue"
        placeholder=""
      >
        <el-option
          v-for="(item, itemIndex) in channels"
          v-bind:key="itemIndex"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select
        style="width: 160px"
        v-model="curUserType.selectValue"
        placeholder=""
      >
        <el-option
          v-for="(item, itemIndex) in userTypes"
          v-bind:key="itemIndex"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <DatePicker2 @datePickedChange="datePickedChange"></DatePicker2>
      <el-button type="primary" @click="doInquery">查询</el-button>
      <el-button type="primary" @click="downloadReport">下载</el-button>
    </div>
    <div class="display-type">
      <div v-loading="loading">
        <CustomTable
          :tableList="tableList"
          :options="tableOptions"
          class="table"
        ></CustomTable>
      </div>
    </div>
  </div>
</template>

<script>
import CustomTable from '@/components/CustomTable'
import DatePicker2 from '@/components/DatePicker2'

export default {
  components: {
    CustomTable,
    DatePicker2
  },
  data() {
    return {
      curChannel: {
        selectValue: 'total',
        content: ''
      },
      channels: this.$store.state.channels,
      curUserType: {
        selectValue: 'All Users',
        content: ''
      },
      userTypes: this.$store.getters.userType,
      datePicked: [
        this.$store.getters.dateTwoDayBefore,
        this.$store.getters.dateOneDayBefore
      ],
      tableOptions: {
        defaultSort: {
          prop: 'period',
          order: 'ascending'
        },
        theader: [
          {
            name: 'period',
            label: '周期',
            sortable: true,
            fixed: true,
            width: '250px'
          },
          {
            name: 'channel',
            label: '平台',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'dau',
            label: 'DAU',
            sortable: true,
            fix: true,
            width: '150px'
          },
          {
            name: 'rechargeMoney',
            label: '总充值金额',
            sortable: true,
            fix: true,
            width: '150px'
          },
          {
            name: 'rechargeUserCount',
            label: '总充值用户数',
            sortable: true,
            fix: true,
            width: '150px'
          },
          
          {
            name: 'purchaseOne',
            label: '购买一次用户数',
            sortable: true,
            fix: true,
            width: '150px'
          },
          {
            name: 'purchaseTwo',
            label: '购买两次用户数',
            sortable: true,
            fix: true,
            width: '150px'
          },
          {
            name: 'purchaseThree',
            label: '购买三次用户数',
            sortable: true,
            fix: true,
            width: '150px'
          },
          {
            name: 'purchaseFour',
            label: '购买四次用户数',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'purchaseFive',
            label: '购买五次用户数',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'purchaseFiveMore',
            label: '购买五次以上用户数',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'repurchaseRate',
            label: '复购率',
            sortable: true,
            fix: true,
            width: '150px'
          },
          {
            name: 'purchaseOneMoney',
            label: '购买一次总金额',
            sortable: true,
            fix: true,
            width: '150px'
          },
          {
            name: 'purchaseTwoMoney',
            label: '购买两次总金额',
            sortable: true,
            fix: true,
            width: '150px'
          },
          {
            name: 'purchaseThreeMoney',
            label: '购买三次总金额',
            sortable: true,
            fix: true,
            width: '150px'
          },
          {
            name: 'purchaseFourMoney',
            label: '购买四次总金额',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'purchaseFiveMoney',
            label: '购买五次总金额',
            sortable: true,
            fix: true,
            width: '180px'
          },
          {
            name: 'purchaseFiveMoreMoney',
            label: '购买五次以上总金额',
            sortable: true,
            fix: true,
            width: '180px'
          }
        ]
      },
      tableList: [],
      loading: true
    }
  },
  beforeCreate() {},
  created() {
    this.getList()
  },
  mounted() {},
  computed: {
    username() {
      return this.$store.getters.username
    },
    userLevel() {
      return this.$store.getters.userLevel
    },
    token() {
      return this.$store.getters.token
    }
  },
  watch: {},
  methods: {
    datePickedChange(date) {
      this.datePicked = date
    },
    //获取视频通话数据
    getList() {
      this.loading = true
      this.$axios({
        type: 'GET',
        url: this.$store.getters.path.reports_repurchase,
        withCredentials: true,
        params: {
          username: this.username,
          token: this.token,
          start: this.datePicked[0],
          end: this.datePicked[1],
          channel: this.curChannel.selectValue,
          userType: this.curUserType.selectValue
        }
      })
        .then(
          res => {
            if (res.data.code === 0) {
              this.tableListBuild(res.data.data)
            } else if (res.data.code === 1001) {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error'
              })
              this.$router.push(this.$route.query.redirect || '/login')
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error'
              })
            }
          },
          err => {
            this.$message({
              showClose: true,
              message: '请求错误:' + err,
              type: 'error'
            })
          }
        )
        .then(() => {
          this.loading = false
        })
    },
    //表格数据
    tableListBuild(data) {
      this.tableList = data
    },
    doInquery() {
      this.getList()
    },
    // 生成并下载主播excel
    downloadReport() {
      window.location.href =
        this.$store.getters.path.reports_download_repurchase +
        '?token=' +
        this.token +
        '&start=' +
        this.datePicked[0] +
        '&end=' +
        this.datePicked[1] +
        '&channel=' +
        this.curChannel.selectValue +
        '&userType=' +
        this.curUserType.selectValue +
        '&username=' +
        this.username
    }
  }
}
</script>


<style lang="stylus" scoped>
@import '../../assets/stylus/variable.styl';

.repurchase_pge {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 20px;
  }
}
</style>
